import React from 'react';
import './dots-loader.scss';
import { Box } from '@mui/material';

const DotsLoader = ({ message, color }: { message?: string; color?: string }) => (
  <Box className="d-flex align-items-center" sx={{ color: '#666666' }}>
    {message && <Box sx={{ mr: 0.3 }}>{message}</Box>}
    <Box className="dots-loader" sx={{ color }}>
      ...
    </Box>
  </Box>
);

export default DotsLoader;
